import Image from 'next/image';
import { Box, Flex, Text } from '@chakra-ui/react';

// Selo "Genuine since 1937" da Ray-Ban (EssilorLuxottica), em PNG com fundo
// transparente.

const SEAL_SRC = '/badges/rayban-certified-seal.png';
const SEAL_ALT = 'Loja certificada Ray-Ban 2026';

/** Marca Ray-Ban, escrita de qualquer forma ("Ray-Ban", "RayBan", "ray ban"). */
export function isRayBanBrand(name: string | null | undefined): boolean {
  return !!name && name.toLowerCase().replace(/[\s-]/g, '').includes('rayban');
}

export function RayBanSeal({ size = 48 }: { size?: number }) {
  return (
    <Box
      flexShrink={0}
      w={`${size}px`}
      h={`${size}px`}
      // O selo tem o centro transparente — em modo escuro, o vermelho sobre
      // o azul-escuro lia-se mal em tamanho pequeno.
      borderRadius="full"
      bg="#FFFFFF"
      title="Loja certificada Ray-Ban — produtos originais"
    >
      <Image src={SEAL_SRC} alt={SEAL_ALT} width={size} height={size} />
    </Box>
  );
}

/**
 * Faixa de destaque para listagens e página inicial — selo + texto, para
 * quem chega a uma lista de Ray-Ban (campanha, newsletter, anúncios) ver
 * logo que a loja é certificada.
 */
export function RayBanCertifiedStrip() {
  return (
    <Flex
      align="center"
      gap={{ base: '12px', md: '16px' }}
      w="100%"
      px={{ base: '14px', md: '20px' }}
      py={{ base: '10px', md: '12px' }}
      borderRadius="16px"
      bg={{ base: '#FFFFFF', _dark: '#0A1B2B' }}
      border="1px solid"
      borderColor={{ base: 'rgba(214,32,39,0.18)', _dark: 'rgba(214,32,39,0.3)' }}
      boxShadow="0 2px 12px rgba(0,0,0,0.04)"
    >
      <RayBanSeal size={52} />
      <Flex flexDir="column" gap="2px" minW="0">
        <Text
          fontSize={{ base: '14px', md: '15px' }}
          fontWeight="800"
          color={{ base: '#0A1B2B', _dark: '#E2EFF5' }}
          lineHeight="1.25"
        >
          Loja certificada Ray-Ban
        </Text>
        <Text
          fontSize={{ base: '12px', md: '13px' }}
          color={{ base: 'rgba(0,0,0,0.55)', _dark: 'rgba(255,255,255,0.55)' }}
          lineHeight="1.4"
        >
          Produtos originais, com garantia · certificação 2026
        </Text>
      </Flex>
    </Flex>
  );
}
